import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import { withStyles } from "@material-ui/core/styles";
import Dialog from "@material-ui/core/Dialog";
import MuiDialogTitle from "@material-ui/core/DialogTitle";
import MuiDialogContent from "@material-ui/core/DialogContent";
import IconButton from "@material-ui/core/IconButton";
import CloseIcon from "@material-ui/icons/Close";
import Typography from "@material-ui/core/Typography";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableContainer from "@material-ui/core/TableContainer";
import TableRow from "@material-ui/core/TableRow";
import axios from "axios";

const styles = (theme) => ({
    root: {
        margin: 0,
        padding: theme.spacing(2),
    },
    closeButton: {
        position: "absolute",
        right: theme.spacing(1),
        top: theme.spacing(1),
        color: theme.palette.grey[500],
    },
});

const DialogTitle = withStyles(styles)((props) => {
    const { children, classes, onClose } = props;
    return (
        <MuiDialogTitle disableTypography>
            <Typography variant="h5">{children}</Typography>
            {onClose ? (
                <IconButton
                    aria-label="close"
                    className={classes.closeButton}
                    onClick={onClose}
                >
                    <CloseIcon />
                </IconButton>
            ) : null}
        </MuiDialogTitle>
    );
});

const DialogContent = withStyles((theme) => ({
    root: {
        padding: theme.spacing(2),
    },
}))(MuiDialogContent);

const GuestDialog = (props) => {
    const [statusLoyalty, setStatusLoyalty] = useState(null);

    useEffect(() => {
        const formData = new FormData();
        formData.append("reservation_id", props?.reservationId);

        axios
            .post(
                `${import.meta.env.VITE_API_URL_SHOP}/index.php?route=api/booking/getLoyaltyInfoByReservationId`,
                formData,
            )
            .then((res) => {
                if (res.data?.loyaltyStatus) {
                    setStatusLoyalty(res.data.loyaltyStatus);
                } else {
                    setStatusLoyalty("none");
                }
            })
            .catch((error) => {
                console.error(error);
            });

        if (!props.curGuest || props.curGuest?.id !== props.guestFromRes?.id) {
            props.getGuestData(props.guestId);
        }
    }, []);

    return (
        <Dialog
            onClose={() => props.setOpenGuestDialog(false)}
            aria-labelledby="customized-dialog-title"
            open={props.openGuestDialog}
        >
            <DialogTitle
                id="customized-dialog-title"
                onClose={() => props.setOpenGuestDialog(false)}
            >
                Данные гостя
            </DialogTitle>
            <DialogContent>
                <TableContainer>
                    {props.curGuest ? (
                        <Table>
                            <TableBody>
                                <TableRow>
                                    <TableCell>Имя</TableCell>
                                    <TableCell>
                                        {props.curGuest.first_name}
                                    </TableCell>
                                </TableRow>
                                <TableRow>
                                    <TableCell>Фамилия</TableCell>
                                    <TableCell>
                                        {props.curGuest.last_name}
                                    </TableCell>
                                </TableRow>
                                <TableRow>
                                    <TableCell>Отчество</TableCell>
                                    <TableCell>
                                        {props.curGuest.middle_name}
                                    </TableCell>
                                </TableRow>

                                <TableRow>
                                    <TableCell>
                                        Статус гостя в программе лояльности
                                    </TableCell>
                                    <TableCell>
                                        {statusLoyalty ? (
                                            statusLoyalty !== "none" ? (
                                                statusLoyalty
                                            ) : (
                                                "Не участвует"
                                            )
                                        ) : (
                                            <div className="progress-circle" />
                                        )}
                                    </TableCell>
                                </TableRow>

                                <TableRow>
                                    <TableCell>Телефон</TableCell>
                                    <TableCell>
                                        {props.curGuest.phone}
                                    </TableCell>
                                </TableRow>
                                <TableRow>
                                    <TableCell>Email</TableCell>
                                    <TableCell>
                                        {props.curGuest.email}
                                    </TableCell>
                                </TableRow>
                            </TableBody>
                        </Table>
                    ) : (
                        <Typography>Нет данных</Typography>
                    )}
                </TableContainer>
            </DialogContent>
        </Dialog>
    );
};

GuestDialog.propTypes = {
    setOpenGuestDialog: PropTypes.func.isRequired,
    openGuestDialog: PropTypes.bool.isRequired,
    curGuest: PropTypes.object,
    guestFromRes: PropTypes.object,
    getGuestData: PropTypes.func,
    guestId: PropTypes.number,
};

export default GuestDialog;
